"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrivateChatsContext = void 0;
const ChatsContext_1 = require("./ChatsContext");
exports.PrivateChatsContext = (0, ChatsContext_1.createChatContext)();
